import React from 'react';
import AppBar from "material-ui/AppBar";
import IconButton from 'material-ui/IconButton';
import {Link} from 'react-router';
import Chevron from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import Arrow from 'material-ui/svg-icons/navigation/arrow-forward';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import Drawer from 'material-ui/Drawer';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import Subheader from 'material-ui/Subheader';
import StartNewFisheryDialog from '../components/StartNewFisheryDialog';
import Avatar from 'material-ui/Avatar';
import md5 from 'js-md5';
import ListItem from 'material-ui/List/ListItem';
import HorizontalLogo from './HorizontalLogo';
import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import DebugSwitch from './DebugSwitch';
import DropDownMenu from 'material-ui/DropDownMenu';


class HeaderBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      newFisheryDialogOpen: false
    }
    this.closeDrawer = this.closeDrawer.bind(this);
  }

  render() {
    let props = this.props;
    let trIDForResponse = props.trIDForResponse;
    if(!trIDForResponse){trIDForResponse = -1} //default to english

    return <AppBar
      style={{position: "absolute", top: 0, backgroundColor: "rgba(255, 255, 255, 0.7)"}}
      titleStyle={{color: '#005387'}}
      title="FishPath Tool"
      onLeftIconButtonClick={() => this.setState({open: true})}
      iconElementLeft={<IconButton><MenuIcon color="#005387" /></IconButton>}
      children={
        <React.Fragment>
          <HorizontalLogo width={240} style={{position: 'absolute', right: 10, top: 10}} />
          <div style={{position: "absolute", left: 205, top: 18, fontSize: 24, maxWidth: 'calc(100vw - 280px - 150px)',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'}}>
        {
          props.breadcrumbs.map((breadcrumb, i) => {
            let title = Object.keys(breadcrumb)[0];
            return <Link key={title} style={{textDecoration: "none", color: "#005387"}} to={breadcrumb[title]}><span>{i === props.breadcrumbs.length - 1 ? <Arrow style={{marginBottom: -5, marginRight: 5, marginLeft: 10}} color="#005387" /> : <Chevron style={{marginBottom: -5, marginRight: 5, marginLeft: 10}} color="#005387" />}{title}</span></Link>
          })
        }
        <Drawer
          docked={false}
          width={200}
          open={this.state.open}
          onRequestChange={(open) => this.setState({open})}
        >
          {
            this.props.email ? <div>
              <ListItem
                leftAvatar={<Avatar size={35} src={`https://www.gravatar.com/avatar/${md5(this.props.email)}?d=mm`} />}
                style={{
                  padding: "20px 16px 20px 62px",
                  textOverflow: "ellipsis",
                  width: 120,
                  overflow: "hidden",
                  whiteSpace: "nowrap"
                }}
                disabled
              >
                {this.props.name || this.props.email}
              </ListItem>
              <MenuItem style={{paddingLeft: 10}} onClick={this.closeDrawer} containerElement={<Link to="/home" />}>My Fisheries</MenuItem>
              <MenuItem style={{paddingLeft: 10}} onClick={this.signOut} containerElement={<Link to="/" />}>Sign Out</MenuItem>
            </div> : <MenuItem onClick={this.closeDrawer} containerElement={<Link to="/" />}>Login</MenuItem>
          }
          <Divider />
          {
            this.props.inResults ? ( <span>
              <Subheader>Results</Subheader>
              <MenuItem onClick={this.closeDrawer} containerElement={<Link to={`/questionnaire/results/${this.props.readOnly ? this.props.responseID + "/" : ""}monitoring`} />}>Summary</MenuItem>
              <MenuItem onClick={this.closeDrawer} containerElement={<Link to={`/questionnaire/results/${this.props.readOnly ? this.props.responseID + "/" : ""}answers`} />}>Answers</MenuItem>
              <MenuItem
                primaryText="Option Lists"
                rightIcon={<ArrowDropRight />}
                menuItems={[
                  <MenuItem onClick={this.closeDrawer} primaryText="Data Collection" containerElement={<Link to={`/questionnaire/results/${this.props.readOnly ? this.props.responseID + "/" : ""}options/monitoring`} />} />,
                  <MenuItem onClick={this.closeDrawer} primaryText="Assessment" containerElement={<Link to={`/questionnaire/results/${this.props.readOnly ? this.props.responseID + "/" : ""}options/assessment`} />} />,
                  <MenuItem onClick={this.closeDrawer} primaryText="Management Measures" containerElement={<Link to={`/questionnaire/results/${this.props.readOnly ? this.props.responseID + "/" : ""}options/controlRules`} />} />,
                ]}
              />
              <MenuItem onClick={this.closeDrawer} containerElement={<Link to={`/questionnaire/results/${this.props.readOnly ? this.props.responseID + "/" : ""}harvestStrategy`} />}>Harvest Strategy</MenuItem>
              <Divider />
              <MenuItem onClick={this.closeDrawer} primaryText="Enforcement" containerElement={<Link to={`/questionnaire/${this.props.enfComplete ?  "results/" : ""}${this.props.readOnly ? this.props.responseID + "/" : ""}enforcement`} />} />
              <Divider />
            </span> ) : null }
          <MenuItem
            primaryText="Reference"
            rightIcon={<ArrowDropRight />}
            menuItems={[
              <MenuItem onClick={this.closeDrawer} primaryText="User Guide" containerElement={<a href={"https://fishpath.github.io/FishPath-Tool-User-Guide/"} target="_blank" rel="noopener noreferrer"/>} />,
              <MenuItem onClick={this.closeDrawer} primaryText="Data Collection" containerElement={<Link to={`/questionnaire/reference/monitoring`} />} />,
              <MenuItem onClick={this.closeDrawer} primaryText="Assessment" containerElement={<Link to={`/questionnaire/reference/assessment`} />} />,
              <MenuItem onClick={this.closeDrawer} primaryText="Management Measures" containerElement={<Link to={`/questionnaire/reference/controlRules`} />} />,
              <MenuItem onClick={this.closeDrawer} primaryText="Harvest Strategy" containerElement={<Link to={`/questionnaire/reference/harvestStrategy`} />} />
            ]}
          />
          { this.props.isAdmin ? <MenuItem onClick={this.closeDrawer} containerElement={<Link to="/admin" />}>Admin</MenuItem> : null }
          <DebugSwitch />
          {(this.props.responseID && this.props.responseID !== "123") ? <div>
            <span style={{fontSize:16, marginLeft:15}}>Question Langauge</span>
            <DropDownMenu
              style={{width: 200, float:"right"}}
              value={trIDForResponse}
              onChange={this.onTrDropDownMenuChange.bind(this)}
            >
              <MenuItem value={-1} primaryText="English" />
              {this.props.translationList.map(lang => <MenuItem key={lang.id} value={lang.id} primaryText={lang.title} />)}

            </DropDownMenu>

          </div>: null}
        </Drawer>
        <StartNewFisheryDialog
          open={this.state.newFisheryDialogOpen}
          onRequestClose={() => this.setState({newFisheryDialogOpen: false})}
          clearResponse={this.props.clearResponse}
          notSaved={this.props.notSaved}
          readOnly={this.props.readOnly}
          router={this.props.router}
        />
        </div>

        </React.Fragment>
      }
    />
  }

  signOut = () => {
    this.props.onSignOut();
    this.props.router.push("/");
  }

  onTrDropDownMenuChange = (event, index, value) => {
    this.setState({
      trIDForResponse: value
    })
    this.props.handleTrChangeForResponse(value, this.props.responseID)
  }

  closeDrawer() {
    this.setState({open: false});
  }
}

export default HeaderBar;
